import api from './api';

export const farmAssistantService = {
  getStatus: async () => {
    const response = await api.get('/assistant/status');
    return response.data;
  },

  chat: async ({ message, history }) => {
    const response = await api.post('/assistant/chat', { message, history });
    return response.data;
  },

  // Saves an action the assistant proposed, through the same endpoint the normal forms use
  runAction: async ({ method, path, payload }) => {
    if (method !== 'post' || !/^\/animals\/\d+\/(yields|tasks|treatments)$/.test(path)) {
      throw new Error('This action is not supported');
    }
    const response = await api.post(path, payload);
    return response.data;
  },
};
